import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import NumberFormat from 'react-number-format';

/**
* Class NumericFilter
* Generic component to generate text filters
**/
class NumericFilter extends Component {
  /**
  * props
  * title : title of the field
  * name : reference name prefix
  * parentFilter : parent filter reference
  **/

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);

    this.state = {
      valueInf: "",
      valueSup: "",
    };
  }

  /**
  * render
  * Rendering component function : display the text filter
  **/
  render() {
    const numericFieldProps = {
      className: "form-control",
      decimalScale: 2,
      thousandSeparator: " ",
      suffix: '€',
      type: "text",
      onValueChange: this.handleValueInfChange.bind(this),
      ref: "valueInf",
      value: this.state.valueInf,
      id: this.props.name + "Inf",
      placeholder: `${this.props.title} minimum`,
    };

    const numericFieldProps2 = {
      ...numericFieldProps,
      onValueChange: this.handleValueSupChange.bind(this),
      ref: "valueSup",
      value: this.state.valueSup,
      id: this.props.name + "Sup",
      placeholder: `${this.props.title} maximum`,
    }

    // Form rendering
    return(
      <div>
        <Col componentClass="filterNumericField" sm={2}>
          <NumberFormat {...numericFieldProps} />
        </Col>

        <Col componentClass="filterNumericField" sm={2}>
          <NumberFormat  {...numericFieldProps2} />
        </Col>
      </div>
    );
  }

  /**
  * reset
  * Reset the value
  **/
  reset() {
    this.setState({
      ...this.state,
      valueInf: "",
      valueSup: "",
    });
  }

  /**
  * handleValueInfChange
  * Handle value inf change
  **/
  handleValueInfChange(values) {
    this.setState({
      ...this.state,
      valueInf: values.value,
    });
    this.props.parentFilter.handleNumericChange(this, {valueInf: values.value, valueSup: this.state.valueSup});
  }

  /**
  * handleValueSupChange
  * Handle value suo change
  **/
  handleValueSupChange(values) {
    this.setState({
      ...this.state,
      valueSup: values.value,
    });
    this.props.parentFilter.handleNumericChange(this, {valueInf: this.state.valueInf, valueSup: values.value});
  }

}

export default NumericFilter;



// WEBPACK FOOTER //
// ./src/views/Helper/GridFilter/NumericFilter.js